var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"review-info"},[_c('ReviewStars',{staticClass:"review-info__stars",attrs:{"max-rating":5,"rating":_vm.rating},on:{"toggle-rating":function($event){return _vm.toggleRating($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }